export const getFiltersOrganizationChartIS = {
	data: undefined,
	loading: false,
	error: null,
	errorShow: false,
	isLoad: false,
};
